import { createAsyncThunk } from '@reduxjs/toolkit';
import { Partner } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreatePartner, FindPartner, PatchPartner } from './interface';

export const findPartner = createAsyncThunk(
  'partner/findPartner',
  async (values: FindPartner, { rejectWithValue }) => {
    try {
      return await Partner.find({ query: values });
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getPartner = createAsyncThunk(
  'partner/getPartner',
  async ({ id }: { id: string }, { rejectWithValue }) => {
    try {
      return await Partner.get(id);
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createPartner = createAsyncThunk(
  'partner/createPartner',
  async (values: CreatePartner, { rejectWithValue }) => {
    try {
      return await Partner.create(values);
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchPartner = createAsyncThunk(
  'partner/patchPartner',
  async ({ id, ...values }: PatchPartner, { rejectWithValue }) => {
    try {
      return await Partner.patch(id, values);
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
